module.exports = __webpack_public_path__ + "img/bg.d818df0f.png";